import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mapName' })
export class MapNamePipe implements PipeTransform {
  transform(key: string, data: { [key: string]: string }, defaultValue?: string): string {
    if (!data || !data[key]) {
      return defaultValue || '';
    } else {
      return data[key];
    }
  }
}

@Pipe({ name: 'mapNameFromArr' })
export class MapNameFromArrPipe implements PipeTransform {
  transform(value: any, data: any[], key = 'name', keySearch = 'value', defaultValue?: string): string {
    if (!data || !data.length) {
      return defaultValue || '';
    }
    const find = data.find((v) => v[keySearch] === value);
    if (!find) {
      return defaultValue || '';
    } else {
      return find[key];
    }
  }
}
